import { useEffect } from "react";

export default function AuthCallback() {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");

        async function exchangeCodeForTokens() {
            const tokenUrl = "https://us-east-15omn7uhsf.auth.us-east-1.amazoncognito.com/oauth2/token";

            const body = new URLSearchParams({
                grant_type: "authorization_code",
                client_id: "6ds10i9komn3frbk4l6gqr9hia",
                code: code,
                redirect_uri: "https://admin.cloudgenomics.net/auth/callback"
            });

            const response = await fetch(tokenUrl, {
                method: "POST",
                headers: {
                "Content-Type": "application/x-www-form-urlencoded"
                },
                body
            });

            const data = await response.json();
            
            if (data.id_token) {
                localStorage.setItem("idToken", data.id_token);
            }
            if (data.access_token) {
                localStorage.setItem("accessToken", data.access_token);
            }
            if (data.refresh_token) {
                localStorage.setItem("refreshToken", data.refresh_token);
            }
            window.location.replace("/super-admin");
        }

        if (code) {
            exchangeCodeForTokens();
        }
    }, []);
  return <div>Exchanging authorization code…</div>;
}
